import { mediaPosts } from "../../data/media";
import { MEDIA_HERO_IMAGE, getMediaImage } from "../../data/blogImages";
import "./mediaMain.css";

function ArrowIcon({ size = 16 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true">
      <path
        d="M7 17 17 7M7 7h10v10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function MediaMain() {
  return (
    <>
      <section className="mm-hero" aria-labelledby="mm-title">
        {MEDIA_HERO_IMAGE && (
          <img
            className="mm-hero-bg"
            src={MEDIA_HERO_IMAGE}
            alt=""
            aria-hidden="true"
          />
        )}

        <div className="mm-container mm-hero-inner">
          <span className="mm-eyebrow">
            <span className="mm-eyebrow-dot" aria-hidden="true" />
            Insights
          </span>

          <h1 className="mm-hero-title" id="mm-title">
            Media
          </h1>

          <p className="mm-hero-text">
            Interviews, rankings and features that recognise our work in
            building the data layer behind AI.
          </p>
        </div>
      </section>

      <section className="mm-section" aria-label="Media coverage">
        <div className="mm-container">
          {mediaPosts.length > 0 ? (
            <div className="mm-grid">
              {mediaPosts.map((item) => {
                const image = getMediaImage(item.image);
                const linked = item.hasExternalLink && item.url;
                const Card = linked ? "a" : "div";
                const cardProps = linked
                  ? {
                      href: item.url,
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "aria-label": `${item.title} (opens in a new tab)`,
                    }
                  : {};

                return (
                  <Card
                    key={item.slug}
                    className={`mm-card${linked ? "" : " mm-card--static"}`}
                    {...cardProps}
                  >
                    <div className="mm-card-image">
                      {image ? (
                        <img src={image} alt={item.imageAlt} loading="lazy" />
                      ) : (
                        <div className="mm-card-placeholder" />
                      )}
                      {linked && (
                        <span className="mm-card-arrow">
                          <ArrowIcon />
                        </span>
                      )}
                    </div>

                    <div className="mm-card-body">
                      <div className="mm-card-meta">
                        <span className="mm-card-category">
                          {(item.source || "Media").toUpperCase()}
                        </span>
                      </div>

                      <h2 className="mm-card-title">{item.title}</h2>

                      {linked && (
                        <span className="mm-card-cta">
                          Read article
                          <ArrowIcon size={14} />
                        </span>
                      )}
                    </div>
                  </Card>
                );
              })}
            </div>
          ) : (
            <p className="mm-empty">No media coverage yet.</p>
          )}
        </div>
      </section>
    </>
  );
}
